module.exports = __webpack_public_path__ + "static/media/haulable-logo.703ba592.png";